import { render, staticRenderFns } from "./lopsandrlopsIntro.vue?vue&type=template&id=37587539&scoped=true"
import script from "./lopsandrlopsIntro.vue?vue&type=script&lang=js"
export * from "./lopsandrlopsIntro.vue?vue&type=script&lang=js"
import style0 from "./lopsandrlopsIntro.vue?vue&type=style&index=0&id=37587539&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37587539",
  null
  
)

export default component.exports